import React from "react";

const InfoChip = ({ icon: Icon, label, value, darkMode, variant = "tile", Text }) => {
	if (variant === "tile") {
		return (
			<div
				className={`rounded-lg border p-3 ${
					darkMode
						? "bg-gray-800/50 border-white/10"
						: "bg-slate-50 border-slate-100"
				}`}
			>
				<div className="flex items-center gap-2 mb-2">
					{Icon && (
						<Icon
							className={`h-4 w-4 ${
								darkMode
									? "text-gray-400"
									: "text-gray-600"
							}`}
						/>
					)}
					<span
						className={`text-xs font-medium ${
							darkMode
								? "text-gray-400"
								: "text-gray-600"
						}`}
					>
						{Text ? <Text>{label}</Text> : label}
					</span>
				</div>
				<div
					className={`text-sm font-semibold ${
						darkMode ? "text-white" : "text-gray-900"
					}`}
				>
					{value}
				</div>
			</div>
		);
	}

	return (
		<div className="flex items-center gap-2">
			{Icon && (
				<Icon
					className={`h-4 w-4 ${
						darkMode ? "text-gray-400" : "text-gray-600"
					}`}
				/>
			)}
			<div>
				<div
					className={`text-xs ${
						darkMode ? "text-gray-400" : "text-gray-600"
					}`}
				>
					{Text ? <Text>{label}</Text> : label}
				</div>
				<div
					className={`text-sm font-semibold ${
						darkMode ? "text-white" : "text-gray-900"
					}`}
				>
					{value}
				</div>
			</div>
		</div>
	);
};

export default InfoChip;
